import {useState} from "react";
import AccounTransForm from "./AccountTranslationFormField";

const CreateAccountTrans = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Account Translations", url: "/account-translations"},
        {content: "Add Account Translations", url: ""},
    ]);

    return (
        <>
            <AccounTransForm crumbs={crumbs} title={"Add Account Translation"} btnText={"Add"}/>
        </>
    )
}
export default CreateAccountTrans;